<template>
  <!-- eslint-disable vue/no-unused-refs -->
  <AppBarLayout>
    <template #default="{ activeHierarchy }">
      <div class="main tw-overflow-x-hidden">
        <brandpattern ref="animation" page="APPBARLAYOUT" />
        <backgroundComponent />
        <ActivePathWrapper
          :active-hierarchy="activeHierarchy"
          :is-button-enable="isEnableButton"
          :button-title="getComponentUiText('app-common-save-change-button-1')"
          :is-call-api="isCallApi"
          @click-button="onSubmit"
        />
        <div
          class="tw-flex org-header tw-gap-[30px] tw-py-[55px] lg:tw-px-[60px] tw-bg-[#ffffff]"
        >
          <GlobalAvatar
            :name="currentOrgName"
            :src="urlAvatar"
            :class-name="'org-detail-org-icon'"
          />
          <div class="tw-flex tw-flex-col tw-justify-center tw-gap-[8px]">
            <span class="org-title-name">{{ currentOrgName }}</span>
            <span class="org-domain">{{ currentOrg.nameLegal }}</span>
          </div>
        </div>
        <div
          class="contain tw-py-[40px] tw-px-[60px] tw-relative xl:tw-py-[55px]"
        >
          <div
            class="tw-flex xl:tw-flex-row tw-flex-col-reverse tw-gap-[40px] xl:tw-gap-[60px]"
          >
            <div class="tw-left-sidebar-contain tw-max-w-[1182px]">
              <div
                id="clickbox-detail"
                class="tw-left-sidebar tw-pb-10 tw-bg-white tw-mb-[30px]"
              >
                <div class="org-detail tw-pt-5 tw-pb-5 tw-pl-10 tw-pr-10">
                  <span class="header-title">{{
                    getComponentUiText(
                      "app-settings-organisation-detail-title-1",
                    )
                  }}</span>
                </div>
                <BForm>
                  <div
                    v-for="(inputItem, inputIndex) in orgDataDetailInput"
                    :key="inputIndex"
                  >
                    <div
                      v-if="inputIndex === 6"
                      class="tw-line tw-mt-10 tw-mb-10"
                    />
                    <div
                      :class="`${inputIndex === 0 ? 'tw-mt-10 ' : 'tw-mt-5'}`"
                    >
                      <div class="tw-pl-10 tw-pr-10">
                        <DatePicker
                          v-if="inputItem.valueField === 'foundedDate'"
                          data-cy-id="org-detail-founded-date"
                          :model-value="form[`${inputItem.valueField}`]"
                          :type="INPUT_TYPE.Date"
                          :title="inputItem.label"
                          :required="false"
                          :validation="v$[`${inputItem.valueField}`]"
                          class="tw-placeholder-[#b7b7b7]"
                          :placeholder="inputItem.label"
                          :is-auto-focus="false"
                          :input-class="`bg-white`"
                          @update:model-value="
                            (value) => (form[`${inputItem.valueField}`] = value)
                          "
                        ></DatePicker>
                        <BaseInput
                          v-if="inputItem.valueField !== 'foundedDate'"
                          :id="inputItem.valueField"
                          v-model="form[`${inputItem.valueField}`]"
                          :validation="v$[`${inputItem.valueField}`]"
                          :validate-on-blur="true"
                          class="tw-placeholder-[#b7b7b7]"
                          :data-cy-id="`org-detail-${inputItem.valueField}`"
                          :type="'text'"
                          :placeholder="inputItem.label"
                          :label="inputItem.label"
                          :label-tooltip="inputItem.hindText"
                          :label-tooltip-class="`tw-w-full`"
                          :is-refresh="true"
                        >
                          <ToggleSwitch
                            v-if="inputItem.type === 'toggle'"
                            data-cy="org-detail-mfa-toggle"
                            :is-checked="form[`${inputItem.valueField}`]"
                            color="#2573E9"
                            @update:is-checked="
                              form[`${inputItem.valueField}`] = $event
                            "
                        /></BaseInput>
                      </div>
                    </div>
                  </div>
                </BForm>
              </div>

              <div
                id="clickbox-setting"
                class="tw-left-sidebar tw-pb-10 tw-bg-white tw-max-w-[1182px]"
              >
                <div class="org-detail tw-pt-5 tw-pb-5 tw-pl-10 tw-pr-10">
                  <span class="header-title">{{
                    getComponentUiText(
                      "app-settings-organisation-specific-setting-title-1",
                    )
                  }}</span>
                </div>
                <BForm>
                  <div
                    v-for="(inputItem, inputIndex) in orgDataSettingInput"
                    :key="inputIndex"
                  >
                    <div
                      v-if="inputIndex === 6"
                      class="tw-line tw-mt-10 tw-mb-10"
                    />
                    <div
                      :class="`${inputIndex === 0 ? 'tw-mt-10 ' : 'tw-mt-5'}`"
                    >
                      <div class="tw-pl-10 tw-pr-10">
                        <DatePicker
                          v-if="inputItem.valueField === 'foundedDate'"
                          data-cy-id="org-detail-founded-date"
                          :model-value="form[`${inputItem.valueField}`]"
                          :type="INPUT_TYPE.Date"
                          :title="inputItem.label"
                          :required="false"
                          :validation="v$[`${inputItem.valueField}`]"
                          class="tw-placeholder-[#b7b7b7]"
                          :placeholder="inputItem.label"
                          :is-auto-focus="false"
                          :input-class="`bg-white`"
                          @update:model-value="
                            (value) => (form[`${inputItem.valueField}`] = value)
                          "
                        ></DatePicker>
                        <BaseInput
                          v-if="inputItem.valueField !== 'foundedDate'"
                          :id="inputItem.valueField"
                          v-model="form[`${inputItem.valueField}`]"
                          :validation="v$[`${inputItem.valueField}`]"
                          :validate-on-blur="true"
                          class="tw-placeholder-[#b7b7b7]"
                          :data-cy-id="`org-detail-${inputItem.valueField}`"
                          :type="'text'"
                          :placeholder="inputItem.label"
                          :label="inputItem.label"
                          :label-tooltip="inputItem.hindText"
                          :label-tooltip-class="`tw-w-full`"
                          :is-refresh="true"
                          :col-input-class="`tw-flex col-input-mfa`"
                        >
                          <ToggleSwitch
                            v-if="inputItem.type === 'toggle'"
                            data-cy="org-detail-mfa-toggle"
                            :is-checked="form[`${inputItem.valueField}`]"
                            color="#2573E9"
                            @update:is-checked="
                              form[`${inputItem.valueField}`] = $event
                            "
                        /></BaseInput>
                      </div>
                    </div>
                  </div>
                </BForm>
              </div>
            </div>

            <div class="tw-right-sidebar">
              <ActionButton
                :profile-actions="detailActions"
                class="tw-max-w-[241px]"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </AppBarLayout>
</template>

<script setup lang="ts">
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import store from "@/store";
import {
  Ref,
  computed,
  onBeforeMount,
  reactive,
  ref,
  watch,
  onMounted,
} from "vue";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import { IOrgDetails, IOrgUpdateInput } from "@/interfaces/orgInterfaces";
import cloneDeep from "lodash/cloneDeep";
import BaseInput from "@/components/common/form/baseInput.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, maxLength, minLength, required } from "@vuelidate/validators";
import { getComponentUiText, compareObjects } from "@/utils/utilities";
import { IEditOrgDetail } from "@/interfaces/orgInterfaces";
import ActionButton, { Action } from "@/components/common/actionButton.vue";
import UserIcon from "@/components/svgs/userIcon.vue";
import AddIcon from "@/components/svgs/addIcon.vue";
import { putOrgProfile } from "@/services/org";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import router from "@/router";
import { routers } from "@/utils/constants";
import GlobalAvatar from "@/components/common/globalAvatar.vue";
import dayjs from "dayjs";
import DatePicker from "@/components/common/datePicker.vue";
import { INPUT_TYPE } from "@/utils/constants";
import ToggleSwitch from "@/components/common/toggleSwitch.vue";
export type inputFiled = {
  label: string;
  hindText: string;
  type?: string;
  required: boolean;
  valueField: string;
};
const isEnableButton = computed(() => {
  const formCompare = {
    ...form,
    foundedDate: form.foundedDate
      ? dayjs(form.foundedDate).format("YYYY-MM-DD")
      : "",
  };
  const oldValueOrgCompare = {
    ...oldValueOrg.value,
    foundedDate: oldValueOrg.value.foundedDate
      ? dayjs(oldValueOrg.value.foundedDate).format("YYYY-MM-DD")
      : "",
  };
  return compareObjects(formCompare, oldValueOrgCompare);
});
const oldValueOrg: Ref<any> = ref({});
let orgDataDetailInput: Ref<inputFiled[]> = ref([]);
let orgDataSettingInput: Ref<inputFiled[]> = ref([]);
const urlAvatar = computed(() => store.getters["Org/getCurrentOrg"].img);
const currentOrgStore: Ref<IOrgDetails> = computed(
  () => store.getters["Org/getOrgDetails"],
);
let currentOrg: Ref<IOrgDetails> = cloneDeep(ref(currentOrgStore.value));
const currentOrgName = computed(() => cloneDeep(currentOrgStore.value.name));
const emitOrg = () => {
  currentOrg.value = cloneDeep(currentOrgStore.value);
  initFormValue();
};
onBeforeMount(() => {
  initFormValue();
});
onMounted(() => {
  setTimeout(() => {
    const autoFocus = document.getElementsByClassName(
      "autoFocus",
    )[0] as HTMLInputElement;
    autoFocus.focus();
  }, 100);
});
const validateFoundedDate = (val) => {
  if (val) {
    const date = dayjs(val);
    return date.isValid() && date.diff(dayjs(), "months", true) <= 12;
  }
  return true;
};

const validateNameCode = (val) => {
  const validChars = /[^a-zA-Z0-9\-_+&()!]/;
  if (val) {
    return !validChars.test(val);
  }
  return false;
};
const rules = {
  name: {
    required: helpers.withMessage(
      () =>
        getComponentUiText("app-common-form-field-required-1", false, {
          field: getComponentUiText(
            "app-settings-organisation-detail-display-name-1",
          ),
        }),
      required,
    ),
  },
  id: {},
  icon: {},
  domainPrimary: {},
  nameLegal: {},
  nameCode: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    minLength: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      minLength(2),
    ),
    maxLength: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      maxLength(4),
    ),
    alphaNum: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      validateNameCode,
    ),
  },
  location: {},
  foundedDate: {
    maxValue: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-detail-founded-date-invalid-1",
        ),
      validateFoundedDate,
    ),
  },
  locationCode: {},
  language: {},
  timezone: {},
  registerNumber: {},
};

const initialForm = {
  name: "",
  id: "",
  icon: "",
  domainPrimary: "",
  nameLegal: "",
  nameCode: "",
  location: "",
  foundedDate: "",
  locationCode: "",
  language: "",
  timezone: "",
  registerNumber: "",
  requireMFA: false,
  secretDisabledPasswordReset: false,
  secretDisabledEmailVerify: false,
  secretDisabledUserInvite: false,
  secretDisabledChecklistRequested: false,
};
const form = reactive(initialForm);
const isLoading = computed(() => store.state.Org.isLoadingOrg);
const v$ = useVuelidate(rules, form, { $scope: false });

watch(currentOrgStore, emitOrg);
const block = {
  detail: "detail",
  setting: "setting",
};

const initFormValue = () => {
  orgDataDetailInput.value = [
    //re format -TODO
    {
      valueField: "name",
      required: true,
      hindText: getComponentUiText(
        "app-settings-organisation-detail-display-name-note-1",
      ),
      label: getComponentUiText(
        "app-settings-organisation-detail-display-name-1",
      ),
    },
    {
      valueField: "nameLegal",
      required: true,
      hindText: "",
      label: getComponentUiText(
        "app-settings-organisation-detail-legal-name-1",
      ),
    },
    {
      valueField: "nameCode",
      required: true,
      hindText: "",
      label: getComponentUiText("app-settings-organisation-detail-name-code-1"),
    },
    {
      valueField: "foundedDate",
      required: false,
      hindText: "",
      label: getComponentUiText(
        "app-settings-organisation-detail-founded-date-1",
      ),
      type: "date",
    },
    // {
    //   valueField: "registerNumber",
    //   required: false,
    //   hindText: "",
    //   label: getComponentUiText(
    //     "app-settings-organisation-detail-register-number-1",
    //   ),
    // },
    // {
    //   valueField: "location",
    //   required: true,
    //   hindText: getComponentUiText(
    //     "app-settings-organisation-detail-location-note-1",
    //   ),
    //   label: getComponentUiText("app-settings-organisation-detail-location-1"),
    // },
    // {
    //   valueField: "timezone",
    //   required: false,
    //   hindText: "",
    //   label: getComponentUiText("app-settings-organisation-detail-timezone-1"),
    // },
    // {
    //   valueField: "language",
    //   required: false,
    //   hindText: "",
    //   label: getComponentUiText("app-settings-organisation-detail-language-1"),
    // },
  ];
  orgDataSettingInput.value = [
    {
      valueField: "requireMFA",
      required: false,
      label: `${getComponentUiText(
        "app-settings-organisation-detail-require-mfa-1",
      )}?`,
      hindText: getComponentUiText(
        "app-settings-organisation-detail-require-mfa-hint-1",
      ),
      type: "toggle",
    },
    {
      valueField: "secretDisabledPasswordReset",
      required: false,
      label: `${getComponentUiText(
        "app-settings-organisation-detail-disable-secret-password-rest-1",
      )}?`,
      hindText: getComponentUiText(
        "app-settings-organisation-detail-disable-secret-password-rest-hint-1",
      ),
      type: "toggle",
    },
    {
      valueField: "secretDisabledEmailVerify",
      required: false,
      label: `${getComponentUiText(
        "app-settings-organisation-detail-disable-secret-email-verify-1",
      )}?`,
      hindText: getComponentUiText(
        "app-settings-organisation-detail-disable-secret-email-verify-hint-1",
      ),
      type: "toggle",
    },
    {
      valueField: "secretDisabledUserInvite",
      required: false,
      label: `${getComponentUiText(
        "app-settings-organisation-detail-disable-user-invite-1",
      )}?`,
      hindText: getComponentUiText(
        "app-settings-organisation-detail-disable-user-invite-hint-1",
      ),
      type: "toggle",
    },
    {
      valueField: "secretDisabledChecklistRequested",
      required: false,
      label: `${getComponentUiText(
        "app-settings-organisation-detail-disable-checklist-requested-1",
      )}?`,
      hindText: getComponentUiText(
        "app-settings-organisation-detail-disable-checklist-requested-hint-1",
      ),
      type: "toggle",
    },
  ];
  const orgValue = cloneDeep(currentOrg.value) as IEditOrgDetail;
  orgDataDetailInput.value.forEach((item) => {
    form[item.valueField] = orgValue[item.valueField];
  });
  orgDataSettingInput.value.forEach((item) => {
    form[item.valueField] = orgValue[item.valueField];
  });

  oldValueOrg.value = cloneDeep(form);
  if (isLoading.value) {
    EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
  }
};
const isCallApi = ref(false);

const onSubmit = async () => {
  isCallApi.value = true;
  try {
    const result = await v$.value.$validate();
    if (result) {
      const payload: IOrgUpdateInput = {
        nameDisplay: form.name,
        nameCode: form.nameCode,
        nameLegal: form.nameLegal,
        requireMFA: form.requireMFA,
        foundedDate: form.foundedDate,
        secretDisabledPasswordReset: form.secretDisabledPasswordReset,
        secretDisabledEmailVerify: form.secretDisabledEmailVerify,
        secretDisabledUserInvite: form.secretDisabledUserInvite,
        secretDisabledChecklistRequested: form.secretDisabledChecklistRequested,
      };
      // remove foundedDate if empty
      if (!payload.foundedDate) {
        delete payload.foundedDate;
      }
      const response = await putOrgProfile(payload);
      if (response.data) {
        oldValueOrg.value = cloneDeep(form);
        store.dispatch("Org/setCurrentOrg", response.data.data);
        store.dispatch("Org/fetchOrgList");
        EventEmitter.emit(EmitterEvents.RELOAD_CURRENT_USER_MEMBERSHIPS);
      }
      const message = getComponentUiText(
        "app-settings-org-update-success-message-1",
      );
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message,
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    }
  } catch (error: any) {
    form.requireMFA = oldValueOrg.value.requireMFA;
    form.secretDisabledPasswordReset =
      oldValueOrg.value.secretDisabledPasswordReset;
    form.secretDisabledEmailVerify =
      oldValueOrg.value.secretDisabledEmailVerify;
    form.secretDisabledUserInvite = oldValueOrg.value.secretDisabledUserInvite;
    form.secretDisabledChecklistRequested =
      oldValueOrg.value.secretDisabledChecklistRequested;
    if (error && error.data) {
      showErrorAPI(error, Org.putOrgProfile);
    }
  } finally {
    isCallApi.value = false;
  }
};

const detailActions: Action[] = [
  {
    icon: AddIcon,
    title: "app-settings-organisation-details-action-manage-domains-1",
    titleClass: "tw-max-w-[149px]",
    onClick: () => handleClickActionButton(routers.settingDomains),
  },
  {
    icon: UserIcon,
    title: "app-settings-organisation-details-action-manage-team-1",
    titleClass: "tw-w-[149px]",
    onClick: () => handleClickActionButton(routers.settingTeamMembers),
  },
];

const handleClickActionButton = (routerUrl: any) => {
  router.push(routerUrl);
};
</script>

<style lang="scss" scoped>
.main {
  // background: linear-gradient(64.12deg, #f1f2f3 0%, #eeeff0 100%);
  width: 100%;
  position: relative;
  overflow-x: hidden;
  height: 100%;
  background: var(--UI-rule-50, rgba(239, 240, 241, 0.5));
}

.org-header {
  .org-title-name {
    font-style: normal;
    font-weight: 600;
    font-size: 25px;
    line-height: 100%;
    color: #211f58;
  }

  .org-domain {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 100%;
    color: #878787;
  }
}
.org-header {
  @media (max-width: 991px) {
    padding-left: 10px;
  }
}

.contain {
  @media (max-width: 991px) {
    padding: 40px 10px;
  }
}

@media (max-width: 991px) {
  .main .active-path-header_wrapper {
    padding: 20px 10px;
  }
}

.contain {
  width: 100%;
  position: relative;
  border-top: 1px solid var(--UI-rule, #eff0f1);
  .tw-left-sidebar-contain {
    flex: 1;
  }
  .tw-left-sidebar {
    border: 1px solid #eff0f1;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.05);
    border-radius: 6px;

    .org-detail {
      border-bottom: 1px solid #eff0f1;

      .header-title {
        color: #211f58;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 27px;
        letter-spacing: 0;
        text-transform: none;
      }
    }
  }

  .tw-right-sidebar {
    max-width: 241px;
    width: 100%;

    .header-subtitle {
      color: var(--brand-navy, #211f58);
      font-size: 12px;
      font-weight: 600;
      line-height: 100%;
      letter-spacing: 1.2px;
      text-transform: uppercase;
      margin-bottom: 25px;
      display: block;
    }

    .btn {
      padding: 0;
      text-align: left;
      margin-bottom: 25px;
      border: 0;

      &:focus {
        box-shadow: none;
      }

      .text-full {
        width: calc(100% - 50px);
        display: inline-block;
        color: var(--brand-navy, #211f58);
        font-size: 15px;
        vertical-align: middle;
        font-weight: 500;
        line-height: 100%;
      }
    }
  }
}

.label-form {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  color: #231f20;
}

.label-note {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: var(--ui-dark-grey, #878787);
  display: block;
}

.tw-text-red-800 {
  color: #f7553c;
}

input {
  border-radius: 6px;
  border: 1px solid var(--ui-rule, #eff0f1);
  background: var(--ui-rule-50, rgba(239, 240, 241, 0.5));
  padding: 18px 20px;
  height: 58px;
  color: #231f20;
  font-size: 13px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.tw-line {
  height: 1px;
  width: 100%;
  background: var(--ui-rule, #eff0f1);
}
</style>

<style>
.org-detail-org-icon {
  width: 90px !important;
  height: 90px !important;
  &&& > span {
    font-size: 26px;
  }
}
</style>
